import { QUOTATION_ACTION, RESET_ACTION } from '../staticData';

export function quotationReducer(state: any, action: any) {
  switch (action.type) {
    case QUOTATION_ACTION.set:
      return { ...state, ...action.payload };

    case RESET_ACTION:
      return {};

    default:
      throw new Error();
  }
}
